import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../utils/Colours";
import UserProfileIcon from "../icons/UserProfileIcon";
import PublicProfile from "../screens/publicProfile/PublicProfile";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useQuery } from "@tanstack/react-query";
import Carousel from "react-native-reanimated-carousel";
import { Image } from "expo-image";
import AppTextInput from "../utils/ColourThemes/AppTextInput";
import Comments from "../icons/Comments";
import { Ionicons } from "@expo/vector-icons";
import ErrorAlertComp from "../alertComp/ErrorAlertComp";
import CommentComponent from "../commentComponent/CommentComponent";
import TopHeaderComponent from "../screens/aTopHeader/TopHeaderComponent";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicThumbnailHeight = Math.round((width / BASE_WIDTH) * 350);
const dynamicCelebThumbnailHeight = Math.round((width / BASE_WIDTH) * 60);
const dynamicCelebThumbnailWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicUserImgThumbnailHeight = Math.round((width / BASE_WIDTH) * 45);
const dynamicUserImghumbnailWidth = Math.round((width / BASE_WIDTH) * 45);

const ViewPublicCelebratoryPull = ({ selectedCelebratory, fromBirthDayComp }) => {
  const [showPublicProfile, setShowPublicProfile] = useState(false);
  const [showViewImages, setShowViewImages] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);
  const [selectedImg, setSelectedImg] = useState(null);
  const [topDoingz, setTopDoingz] = useState([]);
  const [firstFromPull, setFirstFromPull] = useState([]);
  const [userData, setUserData] = useState(null);
  const [isCommentSent, setIsCommentSent] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [isCommentFocused, setIsCommentFocused] = useState(false);
  const [isLoadingComment, setIsLoadingComment] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [commentCount, setCommentCount] = useState(0); // get comment count from the backend on state mount

  const [showComments, setShowComments] = useState(false);

  const [retryCount, setRetryCount] = useState(0);

  const [imageKey, setImageKey] = useState(0);

  useEffect(() => {
    // setUserData(selectedCelebratory?.createdFor)
    getTopDoingz();
    // getFirstDoingInThePull()
    ////console.log('selectedCelebratory', selectedCelebratory)
  }, []); //selectedCelebratory

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const fetchCommentCount = async () => {
      const createdFor = selectedCelebratory.createdFor._id;
      //console.log('createdFor', createdFor)
      try {
        const response = await axiosPrivate.get(`/commentCount/commentCount/${createdFor}`);
        if (response.data?.success) {
          setCommentCount(response.data.count);
        }
      } catch (err) {
        //console.log(err);
      }
    };

    fetchCommentCount();
  }, []);

  const handleViewUserPublicProfile = () => {
    setUserData(selectedCelebratory?.createdFor);
    setShowPublicProfile(true);
  };
  const handleViewTopDoingzUserProfile = (item) => {
    setUserData(item?.userID);
    setShowPublicProfile(true);
  };
  const handleImagePress = (index) => {
    setInitialIndex(index);
    setShowViewImages(true);
  };

  const handleCommentInput = (text) => {
    //console.log('CommentText', text)
    setCommentText(text);
  };

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    // The 'transformations' string includes the optimization flags
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    // Inject the transformations into the URL
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      ////console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      ////console.error('Image failed to load after maximum retries.');
    }
  };

  const userCelebrateUrl =
    selectedCelebratory?.images?.length > 0
      ? selectedCelebratory.images[0]?.url
      : selectedCelebratory?.image;
  const createdForUrl =
    selectedCelebratory?.createdFor?.profilePicture || "../../../assets/profile_image_holder.jpg";

  const newCreatedForUrl = getOptimizedCloudinaryUrl(
    createdForUrl,
    dynamicUserImghumbnailWidth,
    dynamicUserImgThumbnailHeight
  );

  const newUserCelebrateUrl = getOptimizedCloudinaryUrl(
    userCelebrateUrl,
    Math.round(width),
    dynamicThumbnailHeight
  );

  const handlePostCommet = async () => {
    if (commentText == "") {
      return;
    }
    //console.log('createdFor_ID', selectedCelebratory.createdFor?._id)
    //console.log('createdForUsername', selectedCelebratory.createdFor?.username)
    const createdForId = selectedCelebratory.createdFor._id;
    const parentComment = null;
    setIsLoadingComment(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.post("/postComment/postComment", {
        commentText,
        createdForId,
        parentComment,
      });

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        setIsCommentSent(true);

        setCommentText("");
        setCommentCount((prev) => prev + 1);

        // revert back to normal after a few seconds
        setTimeout(() => setIsCommentSent(false), 2500);
      } else {
        ////console.error('Unexpected response:', response);
        setErrorMessage("Error sending comments");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      setErrorMessage("Error sending comments");
      setIsErrorCompVisible(true);
    } finally {
      setIsLoadingComment(false);
    }
  };

  const handleViewComments = () => {
    setShowComments(true);
  };

  const tagColors = {
    Birthday: "#FF5733",
    Beauty: "#d98ffcff",
    "Massive Love": "#33B5FF",
    "Supper fan": "#33FF57",
    Friendship: "#FFC300",
    Appreciation: "#C70039",
    Engagement: "#900C3F",
    Wedding: "#008080",
    Anniversary: "#FF1493",
    Graduation: "#A52A2A",
    Growth: "#4B0082",
    Congratulatory: "#581845",
    "Others...": "#2E8B57",
  };

  // Default function to get tag color (fallback color if tag is missing in the object)
  const getTagColor = (tag) => {
    return tagColors[tag] || "#808080"; // Default gray color for unknown tags
  };

  const getTopDoingz = async () => {
    const username = selectedCelebratory?.createdFor?.username;
    ////console.log('username', username)

    try {
      const response = await axiosPrivate.get(`topDoingz/topDoingz/${username}`);
      ////console.log('response', response)
      if (response.status === 200 || response.status === 201) {
        ////console.log('EXIX:', response.data?.data)
        setTopDoingz(response.data?.data);
      } else {
        ////console.error('Unexpected response:', error.response.data);
        // setErrorMessage('Unexpected response')
        // setIsErrorCompVisible(true)
      }
    } catch (error) {
      if (error.response) {
        ////console.error('Error response from server:', error.response.data);
        const errorMessages =
          error.response.data?.error || error.response.data?.message || "Something went wrong";
        // setErrorMessage(errorMessages);
        // setIsErrorCompVisible(true);
      }
    } finally {
    }
  };

  // const getFirstDoingInThePull = async () => {
  //     const username = selectedCelebratory?.createdFor?.username
  //     ////console.log('username', username)

  //     try {
  //         const response = await axiosPrivate.get(`topFromPull/topFromPull/${username}`)
  //         ////console.log('response', response)
  //         if (response.status === 200 || response.status === 201) {
  //             ////console.log('TopFromPullsd:', response.data?.data)
  //             setFirstFromPull(response.data?.data)

  //         } else {
  //             ////console.error('Unexpected response:', error.response.data);
  //             // setErrorMessage('Unexpected response')
  //             // setIsErrorCompVisible(true)
  //         }

  //     } catch (error) {

  //         if (error.response) {
  //             ////console.error('Error response from server:', error.response.data);
  //             const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
  //             // setErrorMessage(errorMessages);
  //             // setIsErrorCompVisible(true);

  //         }
  //     } finally {

  //     }

  // }

  const handleCarouselSnap = (index) => {
    // Check if the current index is the last image in the array
    if (index === selectedCelebratory.images.length - 1) {
      setTimeout(() => {
        setShowViewImages(false);
      }, 200); // 200ms delay for a smoother feel
    }
  };

  return (
    <ScrollView
      style={styles.componentStyle}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.pullMainContainer}>
        <View style={styles.pullCaptionContainer}></View>
        <View style={styles.headerImgContainer}>
          <Image
            key={imageKey}
            source={{ uri: newUserCelebrateUrl }}
            style={[styles.partyImg, { backgroundColor: "#d6d4d4ff" }]}
            contentFit="cover"
            cachePolicy="disk"
            onError={handleImageError}
          />
        </View>
        <View style={styles.descriptionContainer}>
          <View style={styles.tagsContainer}>
            <Text style={styles.tagsText}>Tag:</Text>
            {fromBirthDayComp ? (
              <View style={styles.tagStyle2}>
                <Text style={styles.tagText}>Birthday</Text>
              </View>
            ) : (
              selectedCelebratory?.selectedTags?.map((tag, index) => (
                <View key={index} style={[styles.tagStyle, { backgroundColor: getTagColor(tag) }]}>
                  <Text style={styles.tagText}>{tag}</Text>
                </View>
              ))
            )}
          </View>
        </View>
        {selectedCelebratory?.images?.length > 0 && (
          <View style={styles.pictureGallaryStyles}>
            <FlatList
              data={selectedCelebratory?.images}
              horizontal
              keyExtractor={(item, index) => index.toString()}
              renderItem={({ item, index }) => {
                const imagesFromCelebratoriesURL = item?.url;

                const newImagesFromCelebratoriesURL = getOptimizedCloudinaryUrl(
                  imagesFromCelebratoriesURL,
                  dynamicCelebThumbnailHeight,
                  dynamicCelebThumbnailWidth
                );

                return (
                  <TouchableOpacity onPress={() => handleImagePress(index)}>
                    <Image
                      source={{ uri: newImagesFromCelebratoriesURL }}
                      key={imageKey}
                      style={[styles.picImageContr, { backgroundColor: "#d6d4d4ff" }]}
                      contentFit="cover"
                      cachePolicy="disk"
                      onError={handleImageError}
                    />
                  </TouchableOpacity>
                );
              }}
            />
          </View>
        )}
        <View style={styles.descriptionContainer}>
          <View>
            <Text style={styles.celebratoryCaptionTxt}>
              {selectedCelebratory?.celebratoryCaption}
            </Text>
          </View>
          <View style={styles.hostUserSubContainer}>
            <UserProfileIcon
              color={Colours.PRIMARY}
              height={dynamicSize(25)}
              width={dynamicSize(25)}
            />
            {/* <Text style={{fontSize:15, fontFamily:'Sen-Regular', color:Colours.PRIMARY}}>Host</Text> */}
            <Text style={styles.createdForTxt}>
              Created For : {selectedCelebratory?.createdFor?.username}
            </Text>
          </View>
        </View>
        <View style={styles.userProfileContainer}>
          <TouchableOpacity
            style={styles.profileContainer}
            onPress={() => {
              handleViewUserPublicProfile();
            }}
          >
            <Image
              key={imageKey}
              source={{ uri: newCreatedForUrl }}
              style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
              contentFit="cover"
              cachePolicy="disk"
              onError={handleImageError}
            />

            <View>
              <Text style={styles.usernameTxt}>{selectedCelebratory?.createdFor?.username}</Text>
              {/* <Text style={styles.realNameTxt}>{selectedCelebratory?.createdFor?.firstname} {selectedCelebratory?.createdFor?.lastname}</Text> */}
            </View>
          </TouchableOpacity>
          {/* <TouchableOpacity style={styles.followButton}>
                        <Text style={styles.followText}>Join</Text>
                    </TouchableOpacity> */}
        </View>
        {/* 
                {firstFromPull.length > 0 ? (
                    <View style={styles.topGivers}>
                        <View style={styles.JoinedNumber}>
                            <Text style={styles.topDoingz}>First in the pull</Text>
                        </View>


                        <View>
                            {firstFromPull?.map((item) => (
                                <TouchableOpacity key={item._id} style={styles.profileContainer2}
                                    onPress={() => handleViewTopDoingzUserProfile(item)}
                                >
                                    <View style={styles.profilePrice}>
                                        {item.userID?.profilePicture ? (
                                            <Image
                                                source={{ uri: item.userID.profilePicture }}
                                                style={styles.userImage}
                                            />
                                        ) : (
                                            <UserProfileIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
                                        )}

                                        <View>
                                            <View style={styles.profilePrice}>
                                                <Text style={styles.usernameTxt}>
                                                    {item.userID?.username || "Unknown User"}
                                                </Text>
                                                <View
                                                    style={[
                                                        styles.tagStyle2,
                                                        { backgroundColor: tagColors[item.selectedTags] || "#ccc" } // fallback color
                                                    ]}
                                                >
                                                    <Text style={styles.tagText}>
                                                        {item.selectedTags || "Others..."}
                                                    </Text>
                                                </View>
                                            </View>


                                        </View>
                                    </View>
                                    {item.comments?.length > 0 && (
                                        <View style={styles.commentSection}>
                                            {item.comments.map((comment) => (
                                                <Text key={comment._id} style={styles.commentTxt}>
                                                    {comment.commentText}
                                                </Text>
                                            ))}
                                        </View>
                                    )}

                                </TouchableOpacity>

                            ))}
                        </View>


                    </View>
                ) : null}
 */}

        <View style={styles.commentContainer}>
          <AppTextInput
            style={[styles.textDescInputStyle, isCommentFocused && styles.focusedBorder]}
            placeholder="Say something ..."
            numberOfLines={5}
            multiline
            value={commentText}
            onFocus={() => setIsCommentFocused(true)}
            onBlur={() => setIsCommentFocused(false)}
            onChangeText={handleCommentInput}
          />
          <View style={styles.commentsPost}>
            <TouchableOpacity style={styles.comments1} onPress={handleViewComments}>
              <Comments
                height={dynamicSize(24)}
                width={dynamicSize(24)}
                color={Colours.PRIMARY_LIGHT}
              />
              <Text style={styles.comments2}> {commentCount == 0 ? "" : commentCount}</Text>
            </TouchableOpacity>
            {isCommentSent ? (
              <>
                <Ionicons name={"checkmark-circle"} size={dynamicSize(20)} color={"green"} />
                <Text style={styles.copyText}>{"Sent!"}</Text>
              </>
            ) : (
              <TouchableOpacity style={styles.commentpPostBtn} onPress={handlePostCommet}>
                {isLoadingComment ? (
                  <ActivityIndicator size="small" color="#fff" />
                ) : (
                  <Text style={styles.postComment}>Post</Text>
                )}
              </TouchableOpacity>
            )}
          </View>
        </View>

        {topDoingz.length > 0 ? (
          <View style={styles.topGivers}>
            <View style={styles.JoinedNumber}>
              <Text style={styles.topDoingz}>Top Doings</Text>
            </View>

            <View>
              {topDoingz?.map((item) => {
                const topDoingsUrl = item.userID.profilePicture;

                const newTopDoingsUrl = getOptimizedCloudinaryUrl(
                  topDoingsUrl,
                  dynamicUserImgThumbnailHeight,
                  dynamicUserImghumbnailWidth
                );

                return (
                  <TouchableOpacity
                    key={item._id}
                    style={styles.profileContainer2}
                    onPress={() => handleViewTopDoingzUserProfile(item)}
                  >
                    {/* <TouchableOpacity style={styles.profileContainer}> */}
                    <View style={styles.profilePrice}>
                      {item.userID?.profilePicture ? (
                        <Image
                          key={imageKey}
                          source={{ uri: newTopDoingsUrl }}
                          style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
                          contentFit="cover"
                          cachePolicy="disk"
                          onError={handleImageError}
                        />
                      ) : (
                        <UserProfileIcon
                          color={Colours.PRIMARY}
                          height={dynamicSize(25)}
                          width={dynamicSize(25)}
                        />
                      )}

                      <View>
                        <View style={styles.profilePrice}>
                          <Text style={styles.usernameTxt}>
                            {item.userID?.username || "Unknown User"}
                          </Text>
                          <View
                            style={[
                              styles.tagStyle2,
                              { backgroundColor: tagColors[item.selectedTags] || "#ccc" }, // fallback color
                            ]}
                          >
                            <Text style={styles.tagText}>{item.selectedTags || "Others..."}</Text>
                          </View>
                        </View>
                        <Text style={styles.amountbyUserTxt}>{item.amount.toLocaleString()}</Text>
                      </View>
                    </View>
                    {item.comments?.length > 0 && (
                      <View style={styles.commentSection}>
                        {item.comments.map((comment) => (
                          <Text key={comment._id} style={styles.commentTxt}>
                            {comment.commentText} {/* Assuming comment has a 'comment' field */}
                          </Text>
                        ))}
                      </View>
                    )}
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>
        ) : null}

        <Modal
          animationType="fade"
          visible={showPublicProfile}
          onRequestClose={() => setShowPublicProfile(false)}
        >
          {/* <TopHeaderComponent headerText={"Table"} hideScreen={() => setShowADoingsScreen(false)} /> */}
          <View style={{ backgroundColor: Colours.LIGHTEST }}>
            <PublicProfile setShowPublicProfile={setShowPublicProfile} userData={userData} />
          </View>
        </Modal>

        <Modal
          animationType="slide"
          visible={showComments}
          onRequestClose={() => setShowComments(false)}
        >
          <TopHeaderComponent headerText={"Comments"} hideScreen={() => setShowComments(false)} />
          <ScrollView
            // ref={scrollViewRef}
            contentContainerStyle={{
              flexGrow: 1,
              paddingBottom: 100,
              backgroundColor: Colours.LIGHTEST,
            }}
          >
            <View style={{ backgroundColor: Colours.LIGHTEST }}>
              <CommentComponent selectedCelebratory={selectedCelebratory} />
            </View>
          </ScrollView>
        </Modal>

        {/* Modal for Viewing Image */}
        {/* <Modal animationType="fade" visible={showViewImages} transparent
                    onRequestClose={() => setShowViewImages(false)}
                >
                    <View style={styles.modalContainer}>
                        <TouchableOpacity onPress={() => setShowViewImages(false)} style={styles.closeButton}>
                            <Text style={styles.closeText}>Close</Text>
                        </TouchableOpacity>

                        {selectedImg && (
                            <Image source={{ uri: selectedImg }} style={styles.fullScreenImage} />
                        )}
                    </View>
                </Modal> */}

        <Modal
          animationType="fade"
          visible={showViewImages}
          transparent
          // Keep onRequestClose for Android's back button
          onRequestClose={() => setShowViewImages(false)}
        >
          <View style={styles.modalContainer}>
            {selectedCelebratory?.images?.length > 0 && (
              <Carousel
                width={width}
                height={height}
                data={selectedCelebratory?.images}
                renderItem={({ item }) => {
                  const celebFullImgUrl = item.url;

                  const newCelebFullImgUrl = getOptimizedCloudinaryUrl(
                    celebFullImgUrl,
                    width,
                    height
                  );

                  return (
                    <View style={styles.fullScreenImageContainer}>
                      <Image
                        key={imageKey}
                        source={{ uri: newCelebFullImgUrl }}
                        style={[styles.fullScreenImage, { backgroundColor: "#6d6d6dff" }]}
                        contentFit="cover"
                        cachePolicy="disk"
                        onError={handleImageError}
                      />
                    </View>
                  );
                }}
                vertical={true}
                loop={false}
                defaultIndex={initialIndex}
                pagingEnabled={true}
                // This is the new prop that handles closing the modal
                onSnapToItem={handleCarouselSnap}
              />
            )}
          </View>
        </Modal>

        <Modal
          visible={isErrorCompVisible}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setIsErrorCompVisible(false)}
        >
          <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
        </Modal>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },

  tagsText: {
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
    color: Colours.PRIMARY,
    textAlign: "justify",
  },
  pictureGallaryStyles: {
    flexDirection: "row",
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(10),
  },
  picImageContr: {
    height: dynamicSize(60),
    width: dynamicSize(60),
    borderRadius: dynamicSize(15),
    marginRight: dynamicSpacing(10),
  },

  celebratoryCaptionTxt: {
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Medium",
    color: Colours.DARKGRAY,
    textAlign: "justify",
  },

  createdForTxt: {
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
    color: Colours.PRIMARY,
  },

  usernameTxt: {
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },

  realNameTxt: {
    fontSize: dynamicFontSize(12),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },

  copyButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
  copyText: {
    color: "green",
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(14),
  },

  followText: {
    fontSize: dynamicFontSize(13),
    color: "white",
    fontFamily: "Sen-Bold",
  },

  pullCaptionContainer: {
    position: "absolute",
    zIndex: 9,
    padding: dynamicSpacing(20),
    height: dynamicSize(400),
    gap: dynamicSpacing(5),
  },

  pullMainContainer: {
    height: "100%",
    backgroundColor: Colours.LIGHTEST,
  },

  categorySubContainer: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(5),
    width: dynamicSize(70),
    height: dynamicSize(20),
  },

  tagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: dynamicSpacing(10),
  },

  categoryJoinedSubContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: dynamicSpacing(15),
    width: dynamicSize(200),
  },

  commentContainer: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    borderRadius: dynamicSize(15),
  },
  commentsPost: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(22),
    //justifyContent: 'space-between',
    alignItems: "center",
  },
  comments1: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: dynamicSpacing(5),
    //  color: Colours.DARKLIGHTGRAY,
  },
  comments2: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },

  commentpPostBtn: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: dynamicSpacing(6),
    paddingHorizontal: dynamicSpacing(15),
    borderRadius: dynamicSize(5),
  },
  postComment: {
    color: "white",
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
  },
  textDescInputStyle: {
    height: dynamicSize(85),
    marginBottom: dynamicSpacing(10),
    // gap: 10,
    padding: dynamicSpacing(15),
    borderWidth: dynamicSize(1),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(15),
    fontFamily: "Sen-Regular",
    fontSize: dynamicSize(15),
    verticalAlign: "top",
    backgroundColor: Colours.LIGHTGRAY,
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },

  datesSubContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },

  headerImgContainer: {
    height: dynamicSize(350),
    zIndex: 0,
    backgroundColor: Colours.PRIMARY_LIGHT,
  },

  partyImg: {
    height: dynamicSize(350),
  },

  descriptionContainer: {
    backgroundColor: "white",
    margin: dynamicSpacing(15),
    marginBottom: 0,
    borderRadius: dynamicSize(15),
    padding: dynamicSpacing(10),
  },

  userProfileContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    margin: dynamicSpacing(15),
    marginBottom: 0,
    borderRadius: dynamicSize(15),
    padding: dynamicSpacing(10),
  },

  followButton: {
    height: dynamicSize(40),
    width: dynamicSize(100),
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colours.PRIMARY,
    borderRadius: dynamicSize(10),
    padding: dynamicSpacing(5),
  },

  hostUserSubContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: dynamicSpacing(10),
    gap: dynamicSpacing(5),
  },

  profileContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: dynamicSpacing(10),
    gap: dynamicSpacing(10),
  },
  profileContainer2: {
    // flexDirection: 'row',
    //  alignItems: 'center',
    paddingTop: dynamicSpacing(10),
    gap: dynamicSpacing(10),
  },
  profilePrice: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: dynamicSpacing(10),
    gap: dynamicSpacing(10),
  },

  userImage: {
    width: dynamicSize(45),
    height: dynamicSize(45),
    borderRadius: 99, // Keeps it circular regardless of screen size
  },

  tagStyle: {
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(15),
    marginRight: dynamicSpacing(1),
  },
  tagStyle2: {
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(20),
    marginRight: dynamicSpacing(1),
    backgroundColor: "#FF5733",
  },

  tagText: {
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Regular",
    color: "white",
  },

  topGivers: {
    margin: dynamicSpacing(15),
    // marginTop: 0,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },

  topDoingz: {
    // marginTop: 10,

    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },

  joinedTxt: {
    // marginTop: 10,

    fontSize: dynamicFontSize(15),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Bold",
  },

  amountbyUserTxt: {
    marginTop: 2,
    fontSize: dynamicFontSize(16),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },

  commentSection: {},
  commentTxt: {
    marginTop: 2,
    fontSize: dynamicFontSize(16),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  fullScreenImage: {
    width: "90%",
    height: "70%",
    resizeMode: "contain",
  },

  modalContainer: {
    flex: 1,
    backgroundColor: "black",
    justifyContent: "center",
    alignItems: "center",
  },

  fullScreenImageContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  fullScreenImage: {
    width: width,
    height: height,
  },
});

export default ViewPublicCelebratoryPull;
